<template>
    <button class="text-primary mb-16 bg-primary-20 rounded px-16 py-24 w-192 leading-normal flex flex-col justify-start items-center group hover:text-secondary hover:bg-white border-2 border-primary-20 hover:border-secondary trans-ease" @click="addComponent" :disabled="disabled">
        <svg-icon :type="image" class="w-48 h-48 mb-16 flex-none"></svg-icon>

        <div class="text-center flex flex-col">
            <span class="text-body font-semibold mb-8 first-letter:uppercase">{{ headTitle }}</span>
            <span class="text-primary text-body-sm">
                <slot></slot>
            </span>
        </div>
    </button>
</template>

<script>
import {mapState, mapActions} from 'pinia';
import {useBrandingStore} from '../../../shared/state/branding';

import SvgIcon from './SvgIcon.vue';

export default {
    components: {
        'svg-icon': SvgIcon,
    },
    props: {
        type: String,
        icon: {
            type: String,
            default: null
        },
        title: {
            type: String,
            default: null
        },
        disabled: Boolean,
    },
    computed: {
        ...mapState(useBrandingStore, [ 'addingComponent' ]),
        image () {
            return this.icon || this.type + '-component';
        },
        headTitle () {
            return this.title ?
                this.$t('site_editor.' + this.title + '.title') :
                this.$t('site_editor.' + this.type + '.title');
        }
    },
    methods: {
        ...mapActions(useBrandingStore, [ 'startConfiguringComponent' ]),
        addComponent () {
            this.startConfiguringComponent({
                type: this.type,
                position: this.addingComponent,
            });
        }
    }
}
</script>
